import { useState } from "react";

import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";

import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import { formRender, initialValues, customerValidations } from "./customer-schema";
import CustomerInfo from "./components/CustomerInfo";
import { Layout } from "ui-components/Layout";

import { Success, Error_ } from "ui-components/Alert";
import { editCustomer } from "services/data.internal.service";
import { SaveButton } from "ui-components/Form";
import { useLocation } from "react-router-dom";
import { getCustomer } from "services/data.internal.service";

function EditCustomer() {
  const location = useLocation();
  const { customerCode } = location.state;
  const [alert, setAlert] = useState(null);
  const [formValues, setFormValues] = useState(null);
  const queryClient = useQueryClient();
  const onSuccess = (data) => setAlert(<Success data={data} onChange={setAlert} />);
  const onError = (data) => setAlert(<Error_ data={data} onChange={setAlert} />);
  useQuery({
    queryKey: ["customer", { customerCode }],
    queryFn: () => getCustomer(customerCode),
    onSuccess: (data) => setFormValues(data.data.data),
    onError,
  });
  const editCustomerMutation = useMutation(editCustomer, {
    onSuccess,
    onError,
  });
  const form = useForm({
    defaultValues: initialValues,
    values: formValues,
    resolver: yupResolver(customerValidations),
  });

  const {
    getValues,
    control,
    handleSubmit,
    formState: { errors, isDirty, isSubmitting },
    setValue,
  } = form;

  const infoProps = {
    mode: "EDIT",
    getValues,
    control,
    errors,
    setValue,
    formRender,
  };
  const onSubmit = (data) => {
    window.scrollTo(0, 0);
    editCustomerMutation.mutate(data, {
      onSuccess: () => queryClient.invalidateQueries(["customer"]),
    });
  };
  return (
    <Layout lg={12}>
      {alert}
      <form onSubmit={handleSubmit(onSubmit)} noValidate>
        <CustomerInfo {...infoProps} />
        <SaveButton label="Save" disabled={!isDirty} url="/setup/customer" />
      </form>
    </Layout>
  );
}

export default EditCustomer;
